import config from "../config";

export const activeCampaignSubmit = (data, formData = true) => {
  return new Promise((resolve, reject) => {
    let fd = new FormData();

    if (formData) {
      for (const key in data) {
        fd.append(key, data[key]);
      }
    }

    let headers = {};

    if (formData) {
      headers["Content-Type"] = "application/json";
    }

    // Convert to query string data
    const fields = fieldsToString(data.field);
    delete data.field;
    const params = new URLSearchParams({
      ...data,
      ...fields,
      jsonp: true
    });

    // This is poorly implemented from ActiveCampaign's API.
    // GET Requests are unsecured by HTTPS when data is being sent through query string.
    fetch(`${config.CONTACT_FORM_ENDPOINT}?${params.toString()}`, {
      method: "GET",
      mode: "no-cors"
    })
      .then(resolve)
      .catch(reject);

    // fetch(config.CONTACT_FORM_ENDPOINT, {
    //   method: "POST",
    //   body: formData ? fd : JSON.stringify(data),
    //   mode: "no-cors",
    //   headers
    // })
    //   .then(resolve)
    //   .catch(reject);
  });
};

function fieldsToString(fields) {
  return fields.reduce((map, field, i) => {
    // Overrides for multi select fields in Brokers form
    if (i === 89) {
      map["field[89][]"] = field;
      return map;
    }
    if (i === 90) {
      map["field[90][]"] = field;
      return map;
    }

    if (field) {
      map[`field[${i}]`] = field;
    }

    return map;
  }, {});
}
